import { useMutation } from '@apollo/client';

import { CreateClientContactInput } from '__generated__/GQL';

import { ClientContactForm } from '../../components/FormModal/hooks/useClientFormModalContext';
import { refetchGetClient } from '../useGetClient';
import { trimClientContactNames } from '../utils';
import { CreateClientContactDocument } from './graphql/createClientContact.gql';

export const useCreateClientContact = (clientId: string) => {
  const [mutation, result] = useMutation(CreateClientContactDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [refetchGetClient(clientId)],
  });

  const createClientContact = (clientContact: ClientContactForm) => {
    // Omit clientContactId we manually defined in createEmptyClientContact()
    // as it's not required in CreateClientContactInput.
    // This custom clientContactId helps us differenciate which contact is updated
    // before submitting the form
    const { clientContactId, ...clientContactRest } =
      trimClientContactNames(clientContact);
    const input: CreateClientContactInput = { ...clientContactRest, clientId };
    return mutation({ variables: { input } });
  };
  return { createClientContact, ...result };
};
